import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <header className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20amber%20coral%20and%20dark%20warm%20tones%2C%20luxurious%20magazine%20editorial%20style%2C%20dramatic%20lighting%20with%20cinematic%20feel%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20smooth%20abstract%20texture%2C%20dark%20elegant%20composition%20with%20golden%20accents&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="黑料吃瓜网 - 最新热点黑料实时更新"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 w-full">
        <h1 className="text-center text-white font-heading">
          <span className="block text-4xl md:text-6xl lg:text-7xl leading-tight">
            今日热点黑料
          </span>
          <span className="block text-3xl md:text-5xl lg:text-6xl leading-tight mt-2">
            网红大瓜实时更新
          </span>
        </h1>
        <p className="mt-6 text-white/80 text-base md:text-lg max-w-2xl text-center leading-relaxed">
          全网最新热点黑料、网红翻车现场、明星不为人知的秘密，一条不落，尽在掌握
        </p>
        <Link
          to="/category/shehui-redian"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white rounded-full text-base font-medium hover:bg-white/30 transition-all duration-300 whitespace-nowrap"
        >
          立即开吃
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="flex items-center gap-2 text-white/60 text-sm">
          <span>向下滚动</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '黑料吃瓜网 - 首页',
          description: '黑料吃瓜网官网入口，今日热点黑料、网红大瓜实时更新，免费吃瓜第一站',
          url: '/',
          isPartOf: {
            '@type': 'WebSite',
            name: '黑料吃瓜网',
            url: '/',
          },
        })}
      </script>
    </header>
  );
}